import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA1gHHczmDlqkh152xfnGzKto2vohmyxm8",
  authDomain: "mmk-industries.firebaseapp.com",
  projectId: "mmk-industries",
  storageBucket: "mmk-industries.firebasestorage.app",
  messagingSenderId: "774247920498",
  appId: "1:774247920498:web:ace93d4b56966a3804a3eb",
  measurementId: "G-EDHHMNMT8Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app; 